<template>
  <div class="projects-container my-3 pb-3">
    <h1 class="text-center mb-3">Side Projects</h1>
    <div class="projects-list">
      <div v-for="(project, idx) in projects" :key="project.link">
        <a :href="project.link" class="project-link" target="_blank" rel="noopener noreferrer">
          <div class="project-row d-flex flex-column flex-md-row align-items-start align-items-md-center pt-2 pb-1">
            <div class="flex-grow-1">
              <h3 class="project-title mb-1">{{project.name}}</h3>
              <p class="project-desc mb-0"><i>{{project.description}}</i></p>
              <div class="project-tags mt-2">
                <span v-for="tag in project.tags" :key="tag" class="project-tag" :style="{ backgroundColor: tagColors[tag] }">{{ tag }}</span>
              </div>
            </div>
          </div>
        </a>
        <div v-if="idx < projects.length - 1" class="project-divider"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tagColors: {
          'AI': '#4B1166',        // darker purple
          'SaaS': '#01507A',      // darker blue
          'Vue': '#265d4a',      // darker green
          'Frontend': '#B28704', // darker yellow
          'Open source': '#205225', // darker green
          'Education': '#7B133B', // darker pink
          'Python': '#1E375A',   // darker blue
          'Package': '#8C2A5A',  // darker pink
          'Science': '#00596B',  // darker teal
          'Cybersecurity': '#7A2410', // darker red
          'Music': '#2C3E50', // dark blue-grey
          'Project management': '#34475E', // dark desaturated blue-grey
        },
        projects: [
          {
            name: 'Hierarchical Priorities',
            description: 'Collaborative project strategy outline tool: a structured, nested bullet list for your project',
            link: 'https://hierarchical-priorities.vangemert.dev/',
            tags: ['Vue', 'Python', 'SaaS', 'Project management']
          },
          {
            name: 'IT Project Quotation AI',
            description: 'My clients can generate a draft project quotation using this AI tool',
            link: 'https://www.vangemert.dev/project-quotation-ai',
            tags: ['AI', 'SaaS', 'Vue', 'Python'],
          },
          {
            name: 'AdministraCLI',
            description: 'Minimal administration tool for small businesses. All data lives in a single local Excel file — no server, no database.',
            link: 'https://github.com/spmvg/AdministraCLI',
            tags: ['Open source', 'Project management', 'Python', 'Package'],
          },
          {
            name: 'Open IT Maintenance Planner',
            description: 'A visual tool to plan, document, and manage IT maintenance tasks and dependencies',
            link: 'https://maintenance-planner.vangemert.dev/',
            tags: ['Vue', 'Frontend', 'Open source', 'Project management'],
          },
          {
            name: 'Developer Badges',
            description: 'Provide recognition for achievements and behaviour in your organisation by awarding badges to your team members',
            link: 'https://www.developerbadges.com/',
            tags: ['SaaS', 'Vue', 'Python', 'Education'],
          },
          {
            name: 'nfoursid',
            description: 'Python implementation of N4SID, Kalman filtering and state-space models',
            link: 'https://github.com/spmvg/nfoursid',
            tags: ['Python', 'Package', 'Open source', 'Science'],
          },
          {
            name: 'evt',
            description: 'Estimators and analysis for extreme value theory (EVT) in Python',
            link: 'https://github.com/spmvg/evt',
            tags: ['Python', 'Package', 'Open source', 'Science'],
          },
          {
            name: 'asdfuzz',
            description: 'Web application fuzzer that automatically detects and fuzzes data in HTTP requests',
            link: 'https://github.com/spmvg/asdfuzz',
            tags: ['Open source', 'Cybersecurity', 'Python', 'Package'],
          },
          {
            name: 'Broken Access Control Scanner',
            description: 'AI command line tool to detect broken access control vulnerabilities in source code',
            link: 'https://github.com/spmvg/broken_access_control_scanner',
            tags: ['Open source', 'Cybersecurity', 'Python', 'Package'],
          },
        ]
      }
    },
    created () {
      document.title = "Side Projects"
    }
  }
</script>

<style scoped>
  .projects-container {
    margin: 0 auto;
    background: rgb(43, 43, 43);
    border-radius: 16px;
    box-shadow: 0 2px 16px rgba(0,0,0,0.12);
    padding: 24px 0 8px 0;
    text-align: left;
  }
  .projects-list {
    width: 100%;
  }
  .project-row {
    transition: background 0.15s;
    padding-left: 24px;
    padding-right: 24px;
    cursor: pointer;
    background: none;
  }
  .project-row:hover {
    background: rgb(30, 30, 30);
  }
  .project-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #fff;
    text-align: left;
  }
  .project-desc {
    font-size: 1rem;
    color: #ccc;
    text-align: left;
  }
  .project-divider {
    height: 1px;
    background: #555;
    margin: 0 24px;
  }
  a.project-link {
    color: inherit;
    text-decoration: none;
    display: block;
  }
  .project-tags {
    margin-top: 0.5rem;
  }
  .project-tag {
    display: inline-block;
    color: #fff;
    border-radius: 12px;
    padding: 0.1rem 0.6rem;
    font-size: 0.875rem;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
  @media (max-width: 767.98px) {
    .project-row.flex-column .project-title,
    .project-row.flex-column .project-desc {
      text-align: left !important;
      width: 100%;
    }
  }
</style>
